import { initializeApp } from "firebase/app"
import { getFirestore } from "firebase/firestore"
import { getAnalytics } from "firebase/analytics"

const firebaseConfig = {
  apiKey: "AIzaSyBWvusgJSvG6uojw6EYeYs_To7yK5SYzlQ",
  authDomain: "yummyphi-6cdfe.firebaseapp.com",
  projectId: "yummyphi-6cdfe",
  storageBucket: "yummyphi-6cdfe.appspot.com",
  messagingSenderId: "742526944667",
  appId: "1:742526944667:web:ac129bea0789887e7a0d3e",
  measurementId: "G-5HFD3P8T78",
}

const app = initializeApp(firebaseConfig)
const db = getFirestore(app)
const analytics = getAnalytics(app)

export { db, analytics }
